
define('template!webshopCategoriesDetailBodyCategoryBodyIndexesView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="header">\n    <div class="language">' +
((__t = ( _.i18n('webshop.category.detail.indexes') )) == null ? '' : __t) +
'</div>\n</div>\n<div class="body">\n  <div class="indexes-container"></div>\n</div>';

}
return __p
};});

